import { userNotesApi } from '@/api'
import { IUserNote } from './types'

export const getUserNotes = async (userId: number): Promise<IUserNote[]> => {
  try {
    const res = await userNotesApi.index({ user_id: userId })
    return res?.data.data ?? []
  } catch (error) {
    console.error('Ошибка получения заметок:', error)
    return []
  }
}

export const removeUserNote = async (id: number): Promise<boolean> => {
  try {
    const res = await userNotesApi.remove({ id: id })
    return res?.data?.status === 'success'
  } catch (error) {
    console.error('Ошибка удаление заметки:', error)
    return false
  }
}

export const createUserNote = async (
  userId: number,
  note: IUserNote,
): Promise<IUserNote | null> => {
  try {
    const { id, ...noteWithoutId } = note

    const data = new FormData()
    data.append('user-id', String(userId))
    data.append('title', noteWithoutId.title)
    data.append('text', noteWithoutId.text)

    const res = await userNotesApi.create(data)

    return res?.data?.data ?? null
  } catch (error) {
    console.error('Ошибка создания заметки:', error)
    return null
  }
}

export const updateUserNote = async (
  note: IUserNote,
): Promise<IUserNote | null> => {
  try {
    const data = new FormData()
    data.append('id', String(note.id))
    data.append('title', note.title)
    data.append('text', note.text)

    const res = await userNotesApi.update(data)

    return res?.data?.data ?? null
  } catch (error) {
    console.error('Ошибка обновления заметки:', error)
    return null
  }
}
